import { apiGet } from './api'

export interface SearchResult {
  type: 'project' | 'equipment' | 'punch' | 'issue' | 'submittal'
  id: number
  title: string
  status: string
  url: string
}

export interface OverdueData {
  overduePunchItems: {
    id: number
    title: string
    status: string
    priority: string
    dueDate: string
    projectId: number
  }[]
  overdueIssues: {
    id: number
    issueNumber: string
    title: string
    status: string
    priority: string
    dueDate: string
    projectId: number
  }[]
  counts: {
    punchItems: number
    issues: number
    total: number
  }
}

export const searchApi = {
  search(q: string): Promise<{ results: SearchResult[] }> {
    return apiGet(`/search?q=${encodeURIComponent(q)}`)
  },

  getOverdue(): Promise<OverdueData> {
    return apiGet('/search/overdue')
  },
}
